<template>
    <table class="table  table-striped table-hover">
        <thead>
        <th>{{$t('components.stocklist.name') | capitalize}}</th>
        <th>{{$t('components.products.catalogNoShort') | capitalize}}</th>
        <th>{{$t('components.stocklist.configNoShort') | capitalize}}</th>
        <th>{{$t('components.stocklist.serialNoShort') | capitalize}}</th>
        <th>{{$t('components.products.quantity') | capitalize}}</th>
        <th>{{$t('components.products.price') | capitalize}}</th>
        <th>{{$t('components.stocklist.acrylicColor') | capitalize}}</th>
        <th>{{$t('components.stocklist.cabinetColor') | capitalize}}</th>
        <th>{{$t('components.stocklist.warehouse') | capitalize}}</th>
        </thead>
        <tbody>
        <tr v-for="item in items" :key="item.configNo+'_'+item.catalogNo+'_'+item.serialNo"
            class="">
            <td>
                <router-link class="text-wellis-gold font-weight-bold" :to="{name: 'app.stocklist.transit.view', params: {
                                                                    uniqueId: item.uniqueId
                                                                }}">
                    {{item.name | cut}}
                </router-link>
            </td>
            <td>
                <router-link :to="{name: 'app.stocklist.transit.view', params: {
                                                                    uniqueId: item.uniqueId
                                                                }}">
                    {{item.catalogNo}}
                </router-link>
            </td>
            <td class="text-wellis-gold font-weight-bold cursor-button" @click="viewConfiguration(item)">
                {{item.configNo}} <i class="fa fa-eye"></i>
            </td>
            <td class="text-wellis-gold font-weight-bold">{{item.serialNo}}</td>
            <td>{{`${item.quantity} ${item.unit}`}}</td>
            <td class="text-wellis-gold font-weight-bold">
                <div v-if="$store.getters['authStore/appSettings'].api.hasPrice">
                    <small class="text-black-50 d-block" v-if="item.price.vat">
                        {{item.price.unitPrice * item.quantity | toPrice(item.price.currency, false)}} + {{$t('components.products.vat')}}
                    </small>
                    {{item.price.unitPrice * item.quantity | toPrice(item.price.currency, item.price.vat)}}
                </div>
                <div v-else>
                    -
                </div>
            </td>
            <td>{{item.acrylicColor}}</td>
            <td>{{item.cabinetColor}}</td>
            <td class="text-wellis-gold font-weight-bold">{{item.warehouse}}</td>
        </tr>
        </tbody>
    </table>
</template>

<script>
    import StocklistApiService from "@/api/stocklist.api";

    export default {
        name: "StocklistTransitTable",
        props: {
            items: Array
        },

        methods: {
            viewConfiguration(item) {
                let loader = this.$loading.show();
                StocklistApiService.transitDetails(item.uniqueId, {
                    with_configuration: true
                }).then(response => {
                    let body = '<h3 class="float-left">' + item.name + ' #' + item.configNo + '</h3><table class="table table-bordered">'
                        + '<tbody>';
                    Object.values(response.data.product.configuration).forEach(line => {
                        let value = line.values.find(x => line.selectedValue === x.optionValueId);
                        if (value) {
                            value = value.description;
                        }
                        body += `<tr><td>${line.description}</td><td>${value || line.selectedValue}</td></tr>`;
                    })
                    this.$swal.fire({
                        html: body + '</tbody></table>',
                        width: "48em"
                    });
                }).finally(() => {
                    loader.hide();
                    loader = null;
                });
            }
        }
    }
</script>

<style scoped>

</style>
